import React from "react";
import {default as MuiMenu} from "@mui/material/Menu";

const Menu = props => {
    const {children, ...other} = props;
    return (
        <MuiMenu
            classes={{
                paper: "ch-menu",
            }}
            {...other}
        >
            {children}
        </MuiMenu>
    )
}

export default Menu;